var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNuevo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9595 6.7454C16.9979 7.36946 16.95 8.07536 16.835 8.8631L16.1354 13.6611C15.5412 17.6612 13.8066 19.0116 10.0595 18.3876L5.56495 17.6305C4.2712 17.4157 3.27454 17.0474 2.5462 16.495C1.15662 15.4617 0.754119 13.7635 1.13745 11.1445L1.84662 6.34642C2.44079 2.34633 4.17537 0.995923 7.92245 1.61998L12.417 2.37703C15.4262 2.87832 16.835 4.18781 16.9595 6.7454Z",
    stroke: "white",
    strokeWidth: 1.2556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7513 13.2107L17.3138 17.8246C16.1159 21.6713 14.1992 22.6943 10.5959 21.4155L6.27382 19.881C4.0984 19.1137 2.8909 18.0497 2.5459 16.4947C3.27423 17.0471 4.2709 17.4154 5.56465 17.6303L10.0592 18.3873C13.8063 19.0114 15.5409 17.661 16.1351 13.6609L16.8346 8.86281C16.9496 8.07507 16.9976 7.36917 16.9592 6.74512C19.2496 8.04438 19.748 10.0086 18.7513 13.2107Z",
    stroke: "white",
    strokeWidth: 1.2556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNuevo);
export default __webpack_public_path__ + "static/media/Nuevo.53a33702620e1178316cb632358302c0.svg";
export { ForwardRef as ReactComponent };